import { render, staticRenderFns } from "./GridDs.vue?vue&type=template&id=5173a550&scoped=true"
import script from "./GridDs.vue?vue&type=script&lang=js"
export * from "./GridDs.vue?vue&type=script&lang=js"
import style0 from "./GridDs.vue?vue&type=style&index=0&id=5173a550&prod&scoped=true&lang=scss"
import style1 from "./GridDs.vue?vue&type=style&index=1&id=5173a550&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5173a550",
  null
  
)

export default component.exports